"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _fp = _interopRequireDefault(require("lodash/fp"));

var _tinyInvariant = _interopRequireDefault(require("tiny-invariant"));

/**
 * Currying function that returns price with tax or price withou tax based on `pricesType` flag value.
 * If `pricesType` is truthy returns price with tax.
 *
 * @param {'B2B' | 'B2C' | 'B2BForeign'} pricesType
 * @param {number | Array<Object>} priceNoTax
 * @param {number | Array<Object>} priceWithTax
 *
 * @returns {number | Array<Object>} Price withot tax if `pricesType` is truthy.
 */
var choosePrice = _fp.default.curry(function (pricesType, priceNoTax, priceWithTax) {
  (0, _tinyInvariant.default)(['B2B', 'B2C', 'B2BForeign'].includes(pricesType), "'choosePrice()' requires `pricesType` have to be one of `'B2B' | 'B2C' | 'B2BForeign'`");
  return pricesType === 'B2B' || pricesType === 'B2BForeign' ? priceNoTax : priceWithTax;
});

var _default = choosePrice;
exports.default = _default;